import * as React from 'react';

import { LaborCostDetailsFragment } from '@portal/schema';

export const LaborCostDetails = ({ laborCostDetails }: { laborCostDetails: LaborCostDetailsFragment }) => (
  <div>{laborCostDetails.formattedCost}</div>
);
